import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import superAdminReducer from "../features/superAdminSlice";
import dashboardReducer from "../features/dashboardSlice";
import outletReducer from "../features/outletSlice";
import driverReducer from "../features/driverSlice";
import commissionReducer from "../features/commissionSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    superAdmin: superAdminReducer,
    dashboard: dashboardReducer,
    outlets: outletReducer,
    drivers: driverReducer,
    commission: commissionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
